export const MESSAGE_TIMEOUT_MS = 4000;
